import { Capacitor } from '@capacitor/core';

export type PlatformKind = 'android' | 'ios' | 'web';

export function platform(): PlatformKind {
  const p = Capacitor.getPlatform();
  return p === 'android' || p === 'ios' ? p : 'web';
}

export const isNative = () => platform() !== 'web';

/** Kör vi som installerad PWA (standalone)? */
export function isStandalonePwa(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(display-mode: standalone)').matches || (navigator as { standalone?: boolean }).standalone === true;
}

export function randomId(prefix = ''): string {
  const b = new Uint8Array(12);
  crypto.getRandomValues(b);
  return prefix + Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
}
